import { getAllUser } from '@/api/user';
import types from '../types';

const state = {
  users: [],
};

const mutations = {
  [types.SET_USERS](state, users) {
    state.users = users;
  }
};

const actions = {
  fetchAllUsers({ commit }) {
    this.tableLoading = true;
    return getAllUser()
      .then(res => {
        const users = res.data.data || [];
        commit(types.SET_USERS, users);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js